"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderProductItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
require("@/components/domains/commerce/product-price");
/**
 * mm-order-product-item
 * 장바구니·주문서·주문완료가 공유하는 주문 상품 한 줄.
 * 상품 이미지와 이름, 선택한 옵션, 가격을 같은 위계로 보여준다.
 */
let OrderProductItem = class OrderProductItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.option = '';
        this.price = '';
        this.imageSrc = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-list-item
        size="large"
        label=${this.name}
        description=${this.option}
        avatar-src=${this.imageSrc}
      >
        ${this.renderPrice()}
      </mm-list-item>
    `;
    }
    renderPrice() {
        if (!this.price)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-product-price slot="trailing" size="large" price=${this.price}></mm-product-price>
    `;
    }
};
OrderProductItem.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], OrderProductItem.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], OrderProductItem.prototype, "option", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], OrderProductItem.prototype, "price", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'image-src' })
], OrderProductItem.prototype, "imageSrc", void 0);
OrderProductItem = __decorate([
    (0, decorators_js_1.customElement)('mm-order-product-item')
], OrderProductItem);
exports.OrderProductItem = OrderProductItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JkZXItcHJvZHVjdC1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsib3JkZXItcHJvZHVjdC1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsK0JBQTRCO0FBQzVCLHVEQUFvRDtBQUVwRDs7OztHQUlHO0FBRUksSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxnQkFBVTtJQUF6Qzs7UUFNdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNULFdBQU0sR0FBRyxFQUFFLENBQUE7UUFDWCxVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ2MsYUFBUSxHQUFHLEVBQUUsQ0FBQTtJQXNCbkUsQ0FBQztJQXBCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O2dCQUdDLElBQUksQ0FBQyxJQUFJO3NCQUNILElBQUksQ0FBQyxNQUFNO3FCQUNaLElBQUksQ0FBQyxRQUFROztVQUV4QixJQUFJLENBQUMsV0FBVyxFQUFFOztLQUV2QixDQUFBO0lBQ0gsQ0FBQztJQUVPLFdBQVc7UUFDakIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFL0IsT0FBTyxJQUFBLFVBQUksRUFBQTs2REFDOEMsSUFBSSxDQUFDLEtBQUs7S0FDbEUsQ0FBQTtJQUNILENBQUM7O0FBN0JNLHVCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7R0FJbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7OENBQVU7QUFDVDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7Z0RBQVk7QUFDWDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7K0NBQVc7QUFDYztJQUFuRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxXQUFXLEVBQUUsQ0FBQztrREFBYztBQVR0RCxnQkFBZ0I7SUFENUIsSUFBQSw2QkFBYSxFQUFDLHVCQUF1QixDQUFDO0dBQzFCLGdCQUFnQixDQStCNUI7QUEvQlksNENBQWdCIn0=